/** Read-only display facts from the dashboard's owner-independent CRM projection.
 * Configuration and admission remain in the signed RDS control plane. */
export interface WebSurfaceFields {
  echo_channel?: string | null;
  echo_surface?: string | null;
  presentation?: {
    brand_id?: string;
    brand_name?: string;
    brand_locale?: string;
    mode?: string;
    sample_book?: boolean;
  } | null;
}
export function webSurfaceLabel(record?: WebSurfaceFields | null): string {
  if (record?.echo_surface !== "partner_demo") return "Web";
  const brand = record.presentation?.brand_name;
  return typeof brand === "string" &&
    brand.length > 0 &&
    brand.length <= 40 &&
    !/[<>]/.test(brand) &&
    [...brand].every((letter) => letter.charCodeAt(0) >= 32)
    ? `Partner demo · ${brand}`
    : "Partner demo";
}
